<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <p>&copy; {{ currentYear }} Oqu All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'AppFooter',
  setup() {
    const currentYear = computed(() => new Date().getFullYear());
    
    return {
      currentYear
    };
  }
});
</script>

<style lang="scss" scoped>
.footer {
  background-color: #1f2937;
  color: white;
  padding: 1.5rem 0;
  
  &-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 2rem;
  }
  
  &-content {
    direction: ltr;
    text-align: center;
    font-size: 0.875rem;
  }
}
</style>